export enum GenerateQuoteCategory {
    INTERIM = "Interim",
    BUDGET = "Budget",
    GOALS = "Goals",
    ULTIMATE = "Ultimate"
}
